<template>
  <img :src="url" />
</template>

<script>
export default {
  data() {
    return {
      url: '',
    }
  },
  mounted() {
    this.url = this.$route.query.url
    document.title = this.$route.query.title
  },
}
</script>
<style scoped lang="scss">
img {
  width: 100%
}

</style>